import { IFormErrors } from '@interfaces/IFormsErrors';

export interface ICoursesChangesState {
  isLoading: boolean;
  success: boolean;
  errors: IFormErrors | null;
}

export const initialCoursesChangesState: ICoursesChangesState = {
  isLoading: false,
  success: false,
  errors: null,
};
